export default __webpack_public_path__ + "static/media/face_3_45.2489fb30.png";